import * as Styled from './styled'

const sizes = {
  small: 18,
  big: 24,
  xSmall: 8,
  xxSmall: 4
}

type TSizeType = keyof typeof sizes

const DotsLoading: React.FC<{
  isHideCentralTransforming?: boolean
  className?: string
  size?: TSizeType
  dotColor?: string
  animation?: 'pulse' | 'loading'
  withoutHeight?: boolean
  transparent?: boolean
  width?: string
}> = ({
  className = '',
  size = 'small',
  dotColor,
  animation = 'pulse',
  withoutHeight,
  transparent,
  width
}) => {
  const dotSize = sizes[size]

  return (
    <Styled.Container
      className={className}
      $withoutHeight={withoutHeight}
      $isTransparent={!!transparent}
      $width={width}
    >
      <Styled.DotsLoadingWrapper>
        {Array.from({ length: 3 }, (_, index) => (
          <Styled.Dot
            key={index}
            className={`dot-${index + 1}`}
            $dotSize={dotSize}
            $dotColor={dotColor}
            $animation={animation}
          />
        ))}
      </Styled.DotsLoadingWrapper>
    </Styled.Container>
  )
}

export default DotsLoading
